import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Por favor ingresa tu correo electrónico');
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Revisa tu correo electrónico');
    } catch (error) {
      const message = error.response?.data?.detail || 'Error al enviar el correo';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="pt-20 min-h-screen bg-[#FAFAF9] flex items-center justify-center" data-testid="forgot-password-success">
        <div className="w-full max-w-md px-6 py-16 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <h1 
            className="text-3xl font-light tracking-tight text-[#1C1917] mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            ¡Correo enviado!
          </h1>
          <p className="text-[#57534E] mb-8">
            Si existe una cuenta con el correo <strong>{email}</strong>, 
            recibirás un enlace para restablecer tu contraseña.
          </p>
          <p className="text-sm text-[#A8A29E] mb-8">
            El enlace expirará en 1 hora.
          </p>
          <Link 
            to="/login" 
            className="btn-primary inline-flex items-center space-x-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Volver al inicio de sesión</span>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20 min-h-screen bg-[#FAFAF9] flex items-center justify-center" data-testid="forgot-password-page">
      <div className="w-full max-w-md px-6 py-16">
        <Link 
          to="/login" 
          className="inline-flex items-center space-x-2 text-sm text-[#57534E] hover:text-[#BA7B7C] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Volver al inicio de sesión</span>
        </Link>

        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-[#FDF8F6] rounded-full flex items-center justify-center mx-auto mb-6">
            <Mail className="w-8 h-8 text-[#BA7B7C]" />
          </div>
          <h1 
            className="text-3xl font-light tracking-tight text-[#1C1917] mb-2"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            ¿Olvidaste tu contraseña?
          </h1>
          <p className="text-[#A8A29E]">
            Ingresa tu correo y te enviaremos un enlace para restablecerla
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
          <div>
            <label className="block text-sm text-[#57534E] mb-2">
              Correo electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] focus:outline-none focus:border-[#BA7B7C] transition-colors"
              placeholder="tu@email.com"
              data-testid="email-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
            data-testid="submit-btn"
          >
            {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
          </button>
        </form>

        <p className="text-center text-sm text-[#A8A29E] mt-8">
          ¿Recordaste tu contraseña?{' '}
          <Link to="/login" className="text-[#BA7B7C] hover:text-[#A36566] transition-colors">
            Iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
